import { DataTable } from "@/components/custom/data-table";
import { Box, Stack, styled } from "@mui/material";
import { getProductsColumns } from "./_components/products-table-column";
import CustomSearchInput from "@/components/custom/custom-search-input";
import { CustomButton } from "@/components/custom/custom-button";
import { useState } from "react";
import ProductDialog from "./_components/product-dialog";
import { useAllProducts } from "@/hooks/use-all-products";
import { useSearchParams } from "react-router-dom";
import {
  createNewProduct,
  updateProduct,
} from "@/services/pricing-config.service";
import CustomPagination from "@/components/custom/custom-pagination";

const RootWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),
}));

const Card = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 12,
  padding: theme.spacing(2.5),
  backgroundColor: theme.palette.background.paper,
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
}));

const ProductsTable = () => {
  const [newProductOpen, setNewProductOpen] = useState(false);
  const [editProduct, setEditProduct] = useState(null);

  const [searchParams] = useSearchParams();
  const searchValue = searchParams.get("search") || "";
  const currentPage = Number(searchParams.get("page") || 0);
  const pageSize = Number(searchParams.get("size") || 10);

  const queryParams = {
    page: currentPage,
    size: pageSize,
    search: searchValue,
  };

  const {
    data: products,
    isLoading,
    isError,
  } = useAllProducts(true, queryParams);

  const handleEditClick = (product) => setEditProduct(product);
  const handleEditClose = () => setEditProduct(null);

  return (
    <RootWrapper>
      <Card>
        <Stack
          direction="row"
          spacing={3}
          alignItems="center"
          justifyContent="space-between"
        >
          <Stack direction="row" spacing={3}>
            <CustomSearchInput
              paramKey="search"
              placeholder="Search product..."
            />
          </Stack>

          <CustomButton
            onClick={() => setNewProductOpen(true)}
            isLoading={false}
            sx={{ height: 35 }}
          >
            Add Product
          </CustomButton>
        </Stack>

        <DataTable
          data={products?.data?.data || []}
          columns={getProductsColumns(handleEditClick)}
          isLoading={isLoading}
          isError={isError}
        />
        <CustomPagination
          total={products?.data?.totalCount ?? 0}
          perPageOptions={[5, 10, 20, 50, 100]}
        />
      </Card>

      <ProductDialog
        open={newProductOpen}
        onClose={() => setNewProductOpen(false)}
        mutationFn={createNewProduct}
      />

      <ProductDialog
        open={Boolean(editProduct)}
        onClose={handleEditClose}
        product={editProduct}
        mutationFn={(payload) =>
          updateProduct({ id: editProduct?.id, ...payload })
        }
      />
    </RootWrapper>
  );
};

export default ProductsTable;
